//import moment from "moment"
import dayjs from "dayjs"
//import utc  from "dayjs/plugin/utc"
//import timezone from "dayjs/plugin/timezone"
import customParseFormat from "dayjs/plugin/customParseFormat"

export var VcDateUtils = (function () {
    dayjs.extend(customParseFormat);
    const DAYS_JS_MAPPINGS={
      "days":"day",
      "hours":"hour",
      "months":"month",
      "years":"year"
    };

    const PERIOD_REGEX = /([a-z]+)([0-9]+)([a-z]+)/;
    return {
      resolveDateRange:function(startDateOrPeriod, endDateOrPeriod) {
        if (!startDateOrPeriod) {
          startDateOrPeriod = "next15days"; // Default to next 15 days if no start date or period is provided
        }

        let startDate = null;
        let endDate = null;

        // Handle startDateOrPeriod
        if (startDateOrPeriod instanceof Date) {
          startDate = startDateOrPeriod;
        } else if (typeof startDateOrPeriod === 'string') {
          // Try to parse as ISO date string first
          const parsedStart = this.dateFromIso(startDateOrPeriod);
          if (parsedStart) {
            startDate = parsedStart;
          } else {
            // If not a valid ISO date, try dynamic date resolution
            const dynamicRange = this.resolveDynamicDate(startDateOrPeriod);
            if (dynamicRange) {
              startDate = dynamicRange[0];
              // If no explicit end date provided and dynamic range has an end, use it
              if (!endDateOrPeriod && dynamicRange[1]) {
                endDate = dynamicRange[1];
              }
            }
          }
        }

        // Handle endDateOrPeriod (only if provided and we don't already have an end date from dynamic range)
        if (endDateOrPeriod && !endDate) {
          if (endDateOrPeriod instanceof Date) {
            endDate = endDateOrPeriod;
          } else if (typeof endDateOrPeriod === 'string') {
            // Try to parse as ISO date string first
            const parsedEnd = this.dateFromIso(endDateOrPeriod);
            if (parsedEnd) {
              endDate = parsedEnd;
            } else {
              // If not a valid ISO date, try dynamic date resolution
              const dynamicRange = this.resolveDynamicDate(endDateOrPeriod);
              if (dynamicRange) {
                endDate = dynamicRange[0]; // Use start date of the dynamic period as end
              }
            }
          }
        }
        return [startDate, endDate];
        
      },
      resolveDateRangeText:function(startDateOrPeriod, endDateOrPeriod) {
        const [startDate, endDate] = this.resolveDateRange(startDateOrPeriod, endDateOrPeriod);
        // Format the result
        if (startDate && endDate) {
          return `${this.formatDateIso(startDate)} - ${this.formatDateIso(endDate)}`;
        } else if (startDate) {
          return this.formatDateIso(startDate);
        }

        return "-"
      },

      resolveDynamicDate:function(period) {
        period=period || "next15days";

        const now = dayjs().startOf('day')
        
        
        
        let match =period.match(PERIOD_REGEX);
        if (match && match.length===4) {
          const relative=match[1];
          const amount=+match[2];
          let unit=DAYS_JS_MAPPINGS[match[3]];
         
          if (relative==="next") {
            return [now.toDate(), now.add(amount, unit).toDate()];
          } else if (relative==="last") {
            return [now.subtract(amount, unit).toDate(), now.toDate()];
          }
        }

        if ("today"===period) {
          return [now.toDate(), null];
        } else if ("yesterday"===period) {
          return [now.subtract(1, 'day').toDate(), null];
        } else if ("tomorrow"===period) {
          return [now.add(1, 'day').toDate(), null];
        } else if ("yeartodate"===period) {
          return [now.startOf('year').toDate(), now.toDate()];
        } else if ("monthtodate"===period) {
          return [now.startOf('month').toDate(), now.toDate()];
        }

        return null;
      },
      formatDateTime2:function(epochSecsOrDate,tz, options) {
        if (epochSecsOrDate===null || epochSecsOrDate===0) {
          return "-";
        }

        var date=(epochSecsOrDate instanceof Date)?epochSecsOrDate:new Date(epochSecsOrDate*1000);
        var options = options || {
          month: 'short', 
           day:'numeric',
           hour: 'numeric', 
           minute: 'numeric',  
           /*hour12: false,*/
           hourCycle: 'h23',
         };
         if (tz) options.timeZone=tz;
         try {
            return (new Intl.DateTimeFormat('en-US', options).format(date));
         } catch(e) {
            console.error("Error formatting date with epoch sec value:"+epochSecsOrDate);
            return "-";
         }
     },
     formatTime:function(epochSecs,tz) {
        return this.formatDateTime2(epochSecs,tz, {
            hour: 'numeric', 
            minute: 'numeric',  
            hour12: false
          });
     },
     formatDate:function(epochSecs,tz) {
        return this.formatDateTime2(epochSecs,tz,{
          year: 'numeric', 
            month: 'short', 
            day:'numeric'
          });
     },
     formatDateShort:function(epochSecs,tz) {
      return this.formatDateTime2(epochSecs,tz,{
          month: 'short', 
          day:'numeric'
        });
      },
      formatMonthShort:function(epochSecs,tz) {
        return this.formatDateTime2(epochSecs,tz,{
            month: 'short', 
          
          });
        },
     formatDateIso:function(epochSecs,tz) {
        var date;
        if (epochSecs instanceof Date) {
            date=epochSecs;
        } else {
            date=new Date(epochSecs*1000);
        }

        
        var options = {
            timeZone: tz
          };
         
          try {
             return (new Intl.DateTimeFormat('sv', options).format(date));
          } catch(e) {
             console.error("Error formatting date with epoch sec value:"+epochSecs);
             return "?";
          }
      },
      dateFromIso:function(dateString) {
        if (!dateString) return null;
        
        const parsed = dayjs(dateString);
        if (!parsed.isValid()) return null;
        
        return parsed.toDate();
      },
      dateFromIsoLocal:function(dateString) {
        if (!dateString) return null;
        
        const parsed = dayjs(dateString);
        if (!parsed.isValid()) return null;
        
        return parsed.toDate();
      },
      toIsoString(date) {
        return dayjs(date).toISOString() 
      },
      formatDateCustom(date, format) {
        return dayjs(date).format(format) 
      },
      truncateToHour(date, offset) {
        offset=offset || 0;
        return new Date(Math.floor(date.getTime()/3600000)*3600000+offset*3600000);
      },
      truncateToMinute(date, offset) {
        offset=offset || 0;
        return new Date(Math.floor(date.getTime()/60000)*60000+offset*60000);
      },
      dateFromString(dateString, formats) {
        if (!dateString) return null;
        dateString=dateString.trim();
        let day;
        if (!formats)  {
          day=dayjs(dateString);
        }  else {
          day=dayjs(dateString, formats);
        }
        if (!day || !day.isValid()) return null;

        return day.toDate();
      },

      addDays(date, days) {
        const dateCopy = new Date(date);
        dateCopy.setDate(date.getDate() + days);
        return dateCopy;
      },
    }
}());
